import TYPES from '../../types';

// Domain
import { AddressEntity } from '../../domain/entities/address-entity';
import { AddressRepository } from '../../domain/repository/address-repository';
import { StateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class SearchAddressQuery extends Query<Promise<Array<AddressEntity>>> {
  @Inject(TYPES.CATALOG_KUSPIT_ADDRESS_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.CATALOG_KUSPIT_ADDRESS_REPOSITORY)
  private readonly repository!: AddressRepository

  internalExecute(postal_code: string): Promise<Array<AddressEntity>> {
    return new Promise((resolve, reject) => {
      if (this.state_manager.state.current_postal_code !== postal_code) {
        this.repository.execute(postal_code)
          .then((items) => {
            this.state_manager.patch({
              items,
              current_postal_code: postal_code,
            });
            resolve(items);
          })
          .catch(reject);
      } else {
        resolve(this.state_manager.state.items);
      }
    });
  }
}
